export function isUrlValid(url: string): boolean {
  try {
    return url === '' || Boolean(new URL(url));
  } catch (e) {
    return false;
  }
}
